import {parseSocialAccount} from './social-account.js';

const platforms={
 Facebook:{key:'facebook',base:'https://www.facebook.com/',hosts:['facebook.com','fb.com','fb.me']},
 Instagram:{key:'instagram',base:'https://www.instagram.com/',hosts:['instagram.com']},
 TikTok:{key:'tiktok',base:'https://www.tiktok.com/@',hosts:['tiktok.com']},
 X:{key:'x_twitter',base:'https://x.com/',hosts:['x.com','twitter.com']},
 LinkedIn:{hosts:['linkedin.com']},
 IMDb:{hosts:['imdb.com']},
};

// Syntax checks never imply that a page exists or belongs to the participant.
export function normalizeProfileAccount(platform,input){
 const value=input.trim();
 if(!value)return {ok:false,error:'Enter a username or profile link.'};
 const spec=platforms[platform];
 let candidate=value;
 const handle=spec?.base&&!/[/:?#\s]/.test(value)&&!spec.hosts.some(host=>value.toLowerCase().replace(/^www\./,'')===host);
 if(handle){
  const username=value.replace(/^@/,'');
  if(!username||/[@&=\\]/.test(username))return {ok:false,error:'Enter a username or profile link.'};
  candidate=spec.base+username;
 }else if(!/^https?:\/\//i.test(candidate))candidate='https://'+candidate;
 let url;
 try{url=new URL(candidate);}catch{return {ok:false,error:'Enter a valid public URL.'};}
 if(!['http:','https:'].includes(url.protocol)||!url.hostname.includes('.')||url.username||url.password||url.port||/\s|\\/.test(candidate))return {ok:false,error:'Enter a valid public URL.'};
 const host=url.hostname.replace(/^(www|m|web)\./,'');
 if(spec&&!spec.hosts.includes(host))return {ok:false,error:'Use a link from '+platform+', or choose Public URL.'};
 if(spec?.key&&!parseSocialAccount(spec.key,url.href).valid)return {ok:false,error:'Use the link to your profile, rather than a post or the website’s home page.'};
 if(platform==='LinkedIn'&&!/^\/(in|company)\/[^/]+\/?$/.test(url.pathname))return {ok:false,error:'Paste the link to your LinkedIn profile.'};
 if(platform==='IMDb'&&!/^\/name\/nm\d+\/?$/.test(url.pathname))return {ok:false,error:'Paste the link to your IMDb name page.'};
 url.hash='';
 return {ok:true,url:url.href,platform,label:url.hostname+url.pathname+(platform==='Facebook'&&url.pathname==='/profile.php'?'?id='+url.searchParams.get('id'):'')};
}

// UI handoff adapter only. It never fetches a page, searches by name, proves
// ownership, or evaluates eligibility. Only explicit design controls simulate
// provider outcomes. Production must replace this with a bounded server check.
export function checkProfileAccount(account,{scenario='not_connected',signal}={}){
 if(!account?.url)return Promise.reject(new Error('A normalized account is required.'));
 if(signal?.aborted)return Promise.reject(new DOMException('Aborted','AbortError'));
 if(scenario==='not_connected')return Promise.resolve({status:'unavailable',reason:'not_connected',simulated:false});
 const status=['found','restricted','not_found','unavailable'].includes(scenario)?scenario:'unavailable';
 return new Promise((resolve,reject)=>{
  const abort=()=>{clearTimeout(timer);reject(new DOMException('Aborted','AbortError'));};
  const timer=setTimeout(()=>{signal?.removeEventListener('abort',abort);resolve({status,simulated:true});},650);
  signal?.addEventListener('abort',abort,{once:true});
 });
}

export function accountCheckCopy(result,platform=''){
 const page=copy=>platform==='Public URL'?{title:copy.title.replace(/^Account/,'Page'),body:copy.body.replaceAll('account','page')}:copy;
 const copy={
  found:{title:'Account found',body:''},
  restricted:{title:'Account couldn’t be accessed',body:'The page may be private or require sign-in. Check that you’ve used the profile link. If it’s correct, save it for GM to review.'},
  not_found:platform==='Public URL'?{title:'Page not found',body:'Check the address, then select Verify.'}:{title:'Account not found',body:'Check the username or paste the full profile link, then select Verify.'},
  unavailable:{title:'Account couldn’t be checked',body:'Select Verify to try again, or save the link for GM to check later.'},
 };
 return page(copy[result.status]??copy.unavailable);
}
